import { Components, Theme } from '@mui/material/styles';

/**
 * This component is actually a composite of multiple MUI components,
 * namely MuiFormControl, MuiTextField, and MuiSelect.
 */
const autoCompleteTheme: Components<Theme>['MuiAutocomplete'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      background: theme.palette.neutralWhite,
      color: theme.palette.black,
      '& .MuiFormControl-root': {
        '& .MuiInputBase-root > fieldset': {
          borderColor: theme.palette.clearBlue,
        },
        '& .MuiInputBase-root.Mui-disabled > fieldset': {
          borderColor: theme.palette.grey.A100,
        },
        '& .MuiInputBase-root.Mui-error > fieldset': {
          borderColor: theme.palette.red[700],
        },
      },
    }),
  },
};

export default autoCompleteTheme;
